import { lazy } from 'react';
import { UnlockedRounded } from '@tools/ui/assets';
import type { AppRouter } from '@tools/ui/types';

export const BASE_PATH = '/crypto-service';

const MainView = lazy(
  () =>
    import(/* webpackChunkName: "CryptoServiceRoutes" */ '../pages/MainView')
);

export const cryptoServiceRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [BASE_PATH, `${BASE_PATH}/*`]
    },
    {
      name: 'Crypto service',
      path: `${BASE_PATH}/main`,
      component: MainView,
      exact: false,
      icon: UnlockedRounded,
      pages: []
    }
  ]
};
